<form id="course-form" class="m-3" [formGroup]="courseFormGroup" (ngSubmit)="courseFormSubmit()">

    <h3 class="mb-3" *ngIf="!edit">Crear nuevo curso</h3>
    <h3 class="mb-3" *ngIf="edit">Editar curso</h3>

    <input type="hidden" formControlName="id">

    <!--
    <div id="course-form-mode" class="mb-3">
        <button type="button" class="btn btn-primary" *ngIf="!pdf" (click)="pdf = !pdf">
            <i class="fas fa-file-upload"></i>
            <span>Subir ficha de curso</span>
        </button>
        <button type="button" class="btn btn-primary" *ngIf="pdf" (click)="pdf = !pdf">
            <i class="fas fa-edit"></i>
            <span>Introducir datos</span>
        </button>
    </div>
    -->

    <div id="course-form-pdf" *ngIf="pdf">
        <label class="d-block mb-3">
            <p class="fw-bold">Ficha:</p>
            <input type="file" name="file[]" class="form-control" accept="application/pdf" (change)="extractPDFInfo($event.target)">
        </label>
    </div>

    <div id="course-form-pdf-status" class="mb-3">
        <div id="course-form-pdf-loading" *ngIf="extractPDFInfoLoading">
            <i class="fas fa-spinner fa-spin me-3"></i>
            <span>Analizando ficha, espere por favor...</span>
        </div>
        <div id="course-form-pdf-success" class="text-success" *ngIf="extractPDFInfoSuccess">
            <i class="fas fa-check"></i>
            <span>¡Ficha analizada correctamente!</span>
        </div>
        <div id="course-form-pdf-error" class="text-danger" *ngIf="extractPDFInfoError">
            <i class="fas fa-times"></i>
            <span>No se pudo extraer la información de la ficha. Por favor, intente con otra ficha o introduzca manualmente la información.</span>
            <!-- <span>Error: {{ errorText }}</span> -->
        </div>
    </div>

    <div id="course-form-inputs" class="mb-3" *ngIf="!pdf">
        <label class="d-block mb-3">
            <p class="fw-bold">Nombre:</p>
            <input type="text" formControlName="name" class="form-control">
        </label>
    
        <label class="d-block mb-3">
            <p class="fw-bold">Número de horas:</p>
            <input type="number" formControlName="hours" class="form-control" min="0">
        </label>

        <label class="d-block mb-3" *ngIf="!edit">
            <p class="fw-bold">Categoría:</p>
            <select id="course-category" class="form-select" formControlName="category">
                <option disabled value="0">Seleccione una opción...</option>
                <option *ngFor="let cat of categories" [value]="cat.id">
                    {{ cat.name }}
                </option>
            </select>
        </label>

        <label class="d-block mb-3">
            <p class="fw-bold">Traducciones:</p>
            <label class="d-inline-block me-3">
                <input type="checkbox" class="me-1" value="es" [disabled]="true" [checked]="translations.includes('es')" (change)="updateTranslations($event.target)">
                <span>Español (es)</span>
            </label>
            <label class="d-inline-block me-3">
                <input type="checkbox" class="me-1" value="ca" [checked]="translations.includes('ca')" (change)="updateTranslations($event.target)">
                <span>Catalán / Catalá (ca)</span>
            </label>
            <label class="d-inline-block me-3">
                <input type="checkbox" class="me-1" value="gl" [checked]="translations.includes('gl')" (change)="updateTranslations($event.target)">
                <span>Gallego / Galego (gl)</span>
            </label>
            <label class="d-inline-block me-3">
                <input type="checkbox" class="me-1" value="en" [checked]="translations.includes('en')" (change)="updateTranslations($event.target)">
                <span>Inglés / English (en)</span>
            </label>
        </label>

        <div id="pdf-units" *ngIf="units.length > 0">
            <p class="fw-bold">Unidades detectadas:</p>
            <ul>
                <li class="mb-3 list-unstyled border-black border-bottom" *ngFor="let unit of units; let u = index;">
                    <p>
                        <span><span class="fw-bold">Unidad de aprendizaje {{ u + 1 }}:</span> {{ unit.name }}</span>
                    </p>
                    <p>
                        <span><span class="fw-bold">Horas:</span> {{ unit.hours }}</span>
                    </p>
                    <p *ngIf="unit.objective != null">
                        <span><span class="fw-bold">Objetivo:</span> {{ unit.objective }}</span>
                    </p>
                    <div class="mb-3" *ngIf="unit.criteria != null">
                        <p class="fw-bold">Criterios de evaluación:</p>
                        <div [innerHTML]="unit.criteria"></div>
                        <!-- <div>{{ unit.criteria }}</div> -->
                    </div>
                    <div class="mb-3" *ngIf="unit.contents != null">
                        <p class="fw-bold">Contenidos:</p>
                        <div [innerHTML]="unit.contents"></div>
                        <!-- <div>{{ unit.contents }}</div> -->
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div id="course-form-status" class="mb-3">
        <div id="course-form-loading" *ngIf="courseFormState == 'submitting'">
            <i class="fas fa-spinner fa-spin me-3"></i>
            <span *ngIf="!edit">Creando curso, espere por favor...</span>
            <span *ngIf="edit">Editando curso, espere por favor...</span>
        </div>
        <div id="course-form-success" class="text-success" *ngIf="courseFormState == 'success'">
            <i class="fas fa-check"></i>
            <span *ngIf="!edit">¡Curso creado correctamente!</span>
            <span *ngIf="edit">¡Curso editado correctamente!</span>
        </div>
        <div id="course-form-error" class="alert alert-danger text-danger" *ngIf="courseFormState == 'error'">
            <div>
                <i class="fas fa-times"></i>
                <span>Errores:</span>
            </div>
            <ul class="my-0">
                <li *ngFor="let error of courseFormErrors">
                    {{ error }}
                </li> 
            </ul>
        </div>
    </div>
    
    <div id="course-form-buttons" class="mb-3">
        <button type="submit" class="btn btn-success me-3" [attr.disabled]="courseFormState == 'submitting' || courseFormState == 'success' ? 'disabled' : null">
            <div *ngIf="!edit">
                <i class="fas fa-check"></i>
                <span>Crear</span>
            </div>
            <div *ngIf="edit">
                <i class="fas fa-save"></i>
                <span>Guardar</span>
            </div>
        </button>

        <button class="btn btn-primary me-3" *ngIf="id != 0 && !edit" (click)="goToNewCourse()">
            <i class="fas fa-book"></i>
            <span>Ir al curso</span>
        </button>
    </div>
</form>